import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { isObject } from "lodash"
import {
  getProvinceCommodityClassifications,
  getProvinceIps,
  getProvinceItemCategories,
  getProvinceProvider,
  getProvinceProvinces,
  getProvinceWarehouses,
} from "store/province-dashboard/province-dashboard-action"
import ProvinceOutForm from "components/ProvinceOut/form"
import {
  getProvinceOutProvinces,
  storeProvinceOut,
  updateProvinceOutDraftsToSubmitted,
} from "store/province-out/province-out-action"
import { provinceOutAction } from "store/province-out/province-out-slice"
import { getProvinceInProviders } from "store/province-in/province-in-action"

const AddProvinceOut = () => {
  // Meta Title
  document.title = "Add Distribution"

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error } = useSelector(state => state.provinceOut)

  // Retrieve providers data from Redux store
  const providers = useSelector(state => state.provinceIn.providers)

  // Retrieve categories data from Redux store
  const categories = useSelector(
    state => state.provinceDashboard.ProvinceItemCategoires
  )

  // Retrieve Unit Classification from Redux store
  const commodityClassifications = useSelector(
    state => state.provinceDashboard.ProvinceCommodityClassifications
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.provinceDashboard.ProvinceIps)

  // Retrieve items data from Redux store
  const items = useSelector(state => state.provinceOut.items)

  // Retrieve provinces data from Redux store
  const provinces = useSelector(state => state.provinceOut.provinces)

  // Retrieve facilities data from Redux store
  const facilities = useSelector(
    state => state.provinceDashboard.provinceFacilities
  )

  // Retrieve receipts data from Redux store
  const receipts = useSelector(state => state.provinceOut.receipts)

  /*
    - handleSubmit: Triggered when the form is submitted
    - values: Contains the form input values
    - Dispatches the action to store the Province Out (Distribution) with the provided values
  */
  const handleSubmit = values => {
    const document = new FormData()
    document.append("distributions", JSON.stringify(values))
    dispatch(storeProvinceOut(document, navigate))
  }

  const handleFinalSubmit = () => {
    dispatch(updateProvinceOutDraftsToSubmitted(navigate))
  }

  // fetch data for form select boxes
  useEffect(() => {
    dispatch(getProvinceInProviders())
    dispatch(getProvinceOutProvinces())
    dispatch(getProvinceIps())
    dispatch(getProvinceCommodityClassifications())

    return () => {
      dispatch(provinceOutAction.resetState())
      dispatch(provinceOutAction.resetProvinces())
      dispatch(provinceOutAction.resetItems())
    }
  }, [])

  return (
    // Province out ( Distribution ) Form
    <ProvinceOutForm
      onSubmit={handleSubmit}
      loading={loading}
      error={error}
      formMode={"Add"}
      providers={providers?.data}
      categories={categories?.data}
      items={items?.data}
      itemLoading={items?.loading}
      ips={ips?.data}
      provinces={provinces?.data}
      facilities={facilities?.data}
      facilityLoading={facilities?.loading}
      receipts={receipts?.data}
      commodityClassifications={commodityClassifications?.data}
      onDraftSubmit={handleFinalSubmit}
    />
  )
}

export default AddProvinceOut
